let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const Monthly = ({ yearTofetch, updateYearToFetch, monthToFetch, updateMonthToFetch }) => {
  return (
    <div className='dailyfilter32'>
      <div className='employeeTile22'>
        <div id='inputreset46' className='inputCustdet  '>
          <select onChange={(e) => updateYearToFetch(e.target.value)} value={yearTofetch}>
            <option value='' disabled selected hidden>
              {yearTofetch}
            </option>
            {new Array(10).fill(0).map((_, i) => (
              <option key={i} value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className='employeeTile22'>
        <div id='inputreset46' className='inputCustdet  '>
          <select onChange={(e) => updateMonthToFetch(e.target.value)} value={monthToFetch}>
            <option value='' disabled selected hidden>
              Select months
            </option>
            {monthNames.map((month, i) => (
              <option disabled={i > new Date().getMonth() && yearTofetch == new Date().getFullYear()} key={i} value={monthNames[i]}>
                {month}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Monthly;
